module.exports = __webpack_public_path__ + "static/fipcwhiterabbit2-c9881632e9443c402475201767a6241d.jpeg";